import { HttpErrorResponse } from '@angular/common/http';

/** The one line for a write that failed for no reason the server named (the banner canon). */
export const GENERIC_ERROR = 'Something went wrong. Please try again.';

/** The one line under a "Couldn't load X" empty state (the load-error canon). */
export const LOAD_ERROR = 'Something went wrong on our side.';

/**
 * The server's own words for a refusal, read off an HTTP error: a string
 * `detail` first; else the first message of a DRF field-error object
 * (`{ field: ['message'] }`), so a validation refusal is never masked behind
 * the generic line; else `fallback`.
 */
export function readError(err: unknown, fallback: string = GENERIC_ERROR): string {
  const body =
    err instanceof HttpErrorResponse
      ? (err.error as { detail?: unknown } | null)
      : ((err as { error?: { detail?: unknown } } | null)?.error ?? null);
  const detail = body?.detail;
  if (typeof detail === 'string' && detail) return detail;
  if (detail && typeof detail === 'object') {
    const first = Object.values(detail as Record<string, unknown>).find(Boolean);
    const message = Array.isArray(first) ? first[0] : first;
    if (typeof message === 'string') return message;
  }
  return fallback;
}
